import "../../../assets/css/overlay.css";
import { useEffect, useRef, useState } from "react";
import PublicHeader from "./PublicHeader.jsx";
import SimpleReactValidator from "simple-react-validator";
import Loader from "../../../components/loader";
import SurveyService from "../../../services/SurveyService";
import InputRating from "../../inputs/InputRating";
import InputText from "../../inputs/InputText";
import CohortService from "../../../services/CohortService";
import { useParams } from "react-router";
import { getSurveyLinkState, giveSurveyLinkStatusMessage, surveys } from "../../../utils/utils";

const initialState = {
    cohortId: null,
    accountAccId: null,
    cohortSurveyLinkId: null,
    cohortParticipantId: null,
    participantEmail: null,
    preQ1Text: null,
    preQ2Rating: null,
    preQ3Rating: null,
    preQ4Rating: null,
    preQ5Rating: null,
    preQ6Rating: null,
};

const JobConfidenceSurvey = () => {
    const [feedbackQuestions, setFeedbackQuestions] = useState({
        ...initialState,
    });
    const validator = useRef(new SimpleReactValidator())
    const [_, setForceUpdate] = useState(false);
    const [isShowLoader, setShowLoader] = useState(false);

    const [showMessage, setShowMessage] = useState({ isShowMessage: false, isLinkValid: false, isFormSubmitted: false, isLinkSubmitted: false, isShowForm: false });
    const { token } = useParams();

    useEffect(async () => {
        setShowLoader(true);
        try {
            const checkSurveyLinkResponse = await CohortService().checkCohortSurveyLink(token);
            const checkCohortSurveyLinkData = checkSurveyLinkResponse.data.data;
            if (checkSurveyLinkResponse.status == 200) {
                const linkState = getSurveyLinkState(checkCohortSurveyLinkData, surveys.jobConfidence)
                setShowMessage(prevState => {
                    return { ...prevState, ...linkState };
                });

                if (!linkState.isShowMessage) {
                    setFeedbackQuestions(prevState => {
                        return {
                            ...prevState, accountAccId: checkCohortSurveyLinkData.accountId,
                            cohortId: checkCohortSurveyLinkData.cohortId, cohortSurveyLinkId: checkCohortSurveyLinkData.cohortSurveyLinkId,
                            cohortParticipantId: checkCohortSurveyLinkData.cohortParticipantId, participantEmail: checkCohortSurveyLinkData.participantEmail
                        }
                    })
                }
            }
        } catch (error) {
            console.debug(error);
            setShowMessage(prevState => {
                return { ...prevState, isShowMessage: true, isLinkValid: true }
            })
        }
        setShowLoader(false);
    }, []);


    const handleChange = (event) => {
        const name = event.target.name;
        const value = event.target.value;
        setFeedbackQuestions((prevState) => {
            return { ...prevState, [name]: value };
        });
    };

    const handleRatingChange = (event) => {
        const name = event.target.name;
        let value = event.target.value;
        value = value == feedbackQuestions[name] ? null : value;
        setFeedbackQuestions((prevState) => {
            return { ...prevState, [name]: value };
        });
    };


    const submitFeedback = async (e) => {
        if (!validator.current.allValid()) {
            validator.current.showMessages();
            setForceUpdate((prevState) => !prevState)
            return;
        }
        setShowLoader(true);
        await SurveyService()
            .saveJobConfidenceSurvey(feedbackQuestions)
        setShowMessage((prevState) => {
            return { ...prevState, isShowMessage: true, isFormSubmitted: true }
        });
        setShowLoader(false);
    };

    return (
        <>
            {isShowLoader &&
                <div className="overlay">
                    <Loader loading={isShowLoader} />
                </div>
            }
            <PublicHeader />
            <div className="wrapper">
                <section className="simulation-header p-0">
                    <h3 className="title">Job Confidence Survey</h3>
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="card">
                                    {(!showMessage.isShowMessage && showMessage.isShowForm) &&
                                        <div className="card-body">
                                            <InputText
                                                label={`Please describe your role in playing this simulation. For
                                                    example, student in an aspiring leader program, student in a
                                                    teacher candidate program, a principal preparation cohort
                                                    member, a professional development assignment, etc.?`}
                                                inputName="preQ1Text"
                                                state={feedbackQuestions.preQ1Text}
                                                handleChange={handleChange}
                                                validator={validator}
                                            />

                                            <InputRating
                                                label="I often get the chance to rehearse in advance the decisions I must make at work."
                                                inputName="preQ2Rating"
                                                state={feedbackQuestions.preQ2Rating}
                                                handleRatingChange={handleRatingChange}
                                                validator={validator}
                                            />

                                            <InputRating
                                                label="I am confident in the decisions I make every day."
                                                inputName="preQ3Rating"
                                                state={feedbackQuestions.preQ3Rating}
                                                handleRatingChange={handleRatingChange}
                                                validator={validator}
                                            />

                                            <InputRating
                                                label="I often get time to reflect on my decisions."
                                                inputName="preQ4Rating"
                                                state={feedbackQuestions.preQ4Rating}
                                                handleRatingChange={handleRatingChange}
                                                validator={validator}
                                            />

                                            <InputRating
                                                label="My decisions have gotten more complicated in recent years."
                                                inputName="preQ5Rating"
                                                state={feedbackQuestions.preQ5Rating}
                                                handleRatingChange={handleRatingChange}
                                                validator={validator}
                                            />

                                            <InputRating
                                                label="I often feel stressed about the decisions I must make at work."
                                                inputName="preQ6Rating"
                                                state={feedbackQuestions.preQ6Rating}
                                                handleRatingChange={handleRatingChange}
                                                validator={validator}
                                            />

                                            <div className="form-group row">
                                                <div className="col-sm-12 text-center">
                                                    <button
                                                        type="button"
                                                        className="btn white float-right"
                                                        onClick={submitFeedback}
                                                    >
                                                        Submit
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    }

                                    {showMessage.isShowMessage &&
                                        <div className="card-body text-center">
                                            <h3>{giveSurveyLinkStatusMessage(showMessage)}</h3>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
}

export default JobConfidenceSurvey;